import React, { useState, useCallback, useEffect } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";

export default function useCreatorProgram(userId) {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch current status and requirements
  const fetchStatus = useCallback(async () => {
    if (!userId) return;

    setLoading(true);

    try {
      const { response, data } = await API.fetchUserCreatorProgramStatus(token, userId);

      if (response.ok) {
        setResult(data);
        setError(null);
      } else {
        setError(data.message);
      }
    } finally {
      setLoading(false);
    }

    console.log("Fetch program status");
  }, [userId]);

  // Join program
  const onJoin = useCallback(async () => {
    setLoading(true);
    try {
      const { response } = await API.joinUserCreatorProgram(token, userId);
      return response.ok;
    } finally {
      setLoading(false);
    }
  }, [token, userId, setLoading]);

  // Leave program
  const onLeave = useCallback(async () => {
    console.log("Do leave");
    try {
      const { response } = await API.leaveUserCreatorProgram(token, userId);
      return response.ok;
    } finally {
      setLoading(false);
    }
  }, [token, userId, setLoading]);

  useEffect(() => {
    fetchStatus();
  }, [userId, fetchStatus]);

  return { loading, error, result, onJoin, onLeave };
}
